import axios from '@fs/zion-axios'

const serviceBase = '/service/discovery'
const commonServiceBase = '/service/discovery/common'

export const getChurchHistoryData = async ({ countryCode }) => {
  const response = await axios.get(`${serviceBase}/wicf/country/${countryCode}/church-history`)
  return response.data
}

export const getFamilyGenerationsData = async () => {
  const response = await axios.get(`${serviceBase}/wicf/family?generations=8`)
  return response.data
}

export const getAncestorImageData = async (personId, sessionId) => {
  const response = await axios.get(`${serviceBase}/wicf/portrait/person/${personId}?token=${sessionId}`)
  return response.data
}

export const getCountryEventsData = async (countryCode) => {
  const response = await axios.get(`${serviceBase}/wicf/country/${countryCode}/timeline`)
  return response.data
}

export const getCountryFoodFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/food`)
}

export const getCountryFamilyFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/family`)
}

export const getCountrySocialFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/social`)
}

export const getCountryTraditionFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/traditions`)
}

export const getCountryChurchFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/church-history`)
}

export const getCountryFacts = ({ countryCode }) => {
  return axios.get(`${serviceBase}/wicf/country/${countryCode}/facts`)
}

export const getFirstConverts = async (pidList) => {
  const list = pidList.join(',')
  const response = await axios.get(`${serviceBase}/wicf/potential-converts?personIds=${list}`)
  return response.data
}

export const getTimelineData = async () => {
  const response = await axios.all([
    axios.get(`/service/discovery/wicf/event/church`),
    axios.get(`/service/discovery/wicf/event/world`),
  ])
  return response
}

export const getRecipesData = async ({ countryCode }) => {
  const response = await axios.get(`${serviceBase}/wicf/country/${countryCode}/recipes`)
  return response.data
}

export const getMemories = async ({ personId }) => {
  return axios.get(`${serviceBase}/common/memory/person/${personId}?count=100`)
}

export const getOrdinances = async ({ personId }) => {
  const response = await axios.get(`${serviceBase}/wicf/ordinances/person/${personId}`)
  return response.data
}

export const postUserFeedback = async ({ description, contactApproval, context }) => {
  const data = {
    description,
    contactApproval,
    context,
  }

  const response = await axios.post(`${serviceBase}/wicf/feedback`, data)
  return response.status
}

export const postPhotoMemories = ({ data }) => {
  return axios.post(`${serviceBase}/common/memory/image`, data)
}

export const postStoriesMemories = ({ data }) => {
  return axios.post(`${serviceBase}/common/memory/story`, data)
}

export const postDocumentMemories = ({ ancestorId, data }) => {
  return axios.post(`${serviceBase}/common/memory/story?ancestorId=${ancestorId}`, data)
}

export const postAudioMemories = ({ ancestorId, data }) => {
  return axios.post(`${serviceBase}/common/memory/audio?ancestorId=${ancestorId}`, data)
}

export const postBirthLocation = async ({ updatedPerson }) => {
  const response = axios.post(`${serviceBase}/common/tree/person/birth/location`, updatedPerson)
  return response.status
}

export const postBirthDate = async ({ ancestorId, birthDate }) => {
  const response = axios.post(`${serviceBase}/common/tree/person/birthdate/${ancestorId}?birthDate=${birthDate}`)
  return response.status
}

export const deleteMemory = async ({ artifactId }) => {
  return axios.delete(`${commonServiceBase}/memory/id/${artifactId}`)
}
